module.exports = "/static/assets/1824f8a20462980dad8a315af06ac9e5.gif";